// removed by extract-text-webpack-plugin
module.exports = {"dark-orange":"#b55808","orange":"#ef8d07","dark-green":"#008300","dark-red":"#a30000","yellow":"#fdc400","red":"#e40000","inputFieldWrapper":"_1Z92FKxImBuw-2NkGXEiJr"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Inputs/Input.css
// module id = 939
// module chunks = 0